import styled, { css } from 'styled-components';
import { SUMMARY_SECONDARY_TYPE } from './experienceSummary.constants';
import { themeColor, whenThemePropEqualsExpectedValue, whenThemePropEqualsTrue } from '../../../theme/getters';
import { paragraph, link } from '../../../theme/typography';

const whenIsSecondaryType = whenThemePropEqualsExpectedValue('type', SUMMARY_SECONDARY_TYPE);
const whenDiscountBorderIsHidden = whenThemePropEqualsTrue('hideDiscountBorder');

const getSecondaryContainerStyles = whenIsSecondaryType(
  () => css`
    color: ${themeColor('gray')};
  `
);

const getHiddenBorderStyles = whenDiscountBorderIsHidden(
  () => css`
    cursor: unset;
    text-decoration: none;
  `
);

export const Container = styled.div`
  ${paragraph};
  text-align: left;
  ${getSecondaryContainerStyles};
`;

export const DiscountInfo = styled.span`
  ${link};
  ${paragraph};
  ${getSecondaryContainerStyles};
  ${getHiddenBorderStyles};
  text-transform: none;
`;
